export default __webpack_public_path__ + "static/2.1-5dc84785dba76e97d3f350158a81bb38.webp";